import Quiz from './quiz'
import PartTypes from './partTypes'
import Memory from './memory'
import Helper from './helper'
import Flashcard from '@/model/flashcard';
import PartDataTypes from '@/model/partDataTypes';

export default class Part {
  constructor (partName, lesson, partJson) {
    this.name = partName
    this.lesson = lesson

    this.title = partJson.title
    this.titleShort = partJson.titleShort || partJson.title
    this.description = partJson.description
    this.type = partJson.type
    this.format = partJson.format || 'json'
    this.color = partJson.color ? partJson.color : lesson.color
    this.category = this.lesson.category
    this.to = `${this.lesson.to}/${partName}/${this.type}`

    this.dataType = partJson.dataType
    if (!this.dataType) {
      switch (this.type) {
        case PartTypes.TEXT:
          this.dataType = PartDataTypes.TEXT
          break;
        case PartTypes.QUIZ:
          this.dataType = PartDataTypes.QUIZ
          break;
        case PartTypes.FLASHCARD:
          this.dataType = PartDataTypes.QUIZ
          break;
        case PartTypes.MEMORY:
          this.dataType = PartDataTypes.PAIRS
          break;
      }
    }

    this.prev = null
    this.next = null
  }

  static async create(lesson, partName) {
    const partJson = await Helper.loadJson(`lessons/${lesson.name}/parts/${partName}/part.json`)
    return new Part(partName, lesson, partJson);
  }

  getNext () {
    return this.next
  }

  getPrevious () {
    return this.prev
  }

  async getContent () {
    if (this.type !== PartTypes.TEXT) {
      throw Error(`getContent not supported for type "${this.type}"`)
    }
    return await Helper.loadText(`lessons/${this.lesson.name}/parts/${this.name}/content.md`)
  }

  async getData () {
    if (this.dataType !== PartDataTypes.QUIZ && this.dataType !== PartDataTypes.PAIRS) {
      throw Error(`getData not supported for data type "${ this.dataType }"`)
    }

    let data
    if (this.format === 'yaml') {
      data = await Helper.loadYaml(`lessons/${this.lesson.name}/parts/${this.name}/data.yaml`)
    } else {
      data = await Helper.loadJson(`lessons/${this.lesson.name}/parts/${this.name}/data.json`)
    }

    if (data.template !== undefined && data.questions !== undefined) {
      let indexMap = new Map()
      for (let i = 0; i < data.template.answers.length; i++) {
        indexMap.set(data.template.answers[i].title, i)
      }

      for (let i = 0; i < data.questions.length; i++) {
        let question = data.questions[i]

        question.type = question.type || data.template.type

        let answers = []
        for (let j = 0; j < question.answers.length; j++) {
          let answer = question.answers[j]
          answers[indexMap.get(answer.title)] = answer
        }

        for (let j = 0; j < data.template.answers.length; j++) {
          if (answers[j] !== undefined) {
            continue
          }
          answers[j] = {
            ...data.template.answers[j]
          }
        }
        question.answers = answers
      }
    }

    return data
  }

  async getQuiz () {
    if (this.type !== PartTypes.QUIZ && this.type !== PartTypes.FLASHCARD) {
      throw Error(`getQuiz not supported for type "${this.type}"`)
    }
    return Quiz.create(this)
  }

  async getFlashcard () {
    if (this.dataType === PartDataTypes.PAIRS) {
      return Flashcard.createFromPairs(this)
    }
    if (this.dataType === PartDataTypes.QUIZ) {
      return Flashcard.createFromQuiz(this)
    }
    throw Error(`getFlashcard not supported for data type "${ this.dataType }"`)
  }

  async getMemory () {
    if (this.dataType !== PartDataTypes.PAIRS) {
      throw Error(`getMemory not supported for data type "${ this.dataType}"`)
    }
    return Memory.create(this)
  }

  async getSlides () {
    if (this.type !== PartTypes.QUIZ && this.type !== PartTypes.FLASHCARD) {
      throw Error(`getSlides not supported for type "${this.type}"`)
    }
    return await this.getData()
  }
}
